import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { hideModal, resetModal } from 'redux/modules/modal';
import { 
	USER_ROLE_ADMIN,
	XC_URL,
	PRODUCT_NAME_PARAM,
	PRODUCT_QUANTITY_PARAM,
	PRODUCT_SOURCE_PARAM,
	PERIOD_PARAM,
	PRODUCT_LANGUAGE_PARAM,
	MAGIX_EMAIL_PARAM,
	MAGIX_SERIAL_PARAM,
	MAGIX_CATEGORY_PARAM,
	COUPON_ID_PARAM,
	CURRENCY_PARAM,
	UPGRADE_POPUP_PARAM,
	REAL_ESTATE_PLAN_PARAM,
	EXTERNAL_REDIRECT_PARAM,
	INTERNAL_REDIRECT_PARAM
} from '../../config';
import PropTypes from 'prop-types';
import { showChargebeeLoader } from 'redux/modules/chargebeeLoader';
import { getSubscriptionRedirectUrl } from '../../utils/subscription';
import { showPreloader } from 'redux/modules/preloader';
import { getCurrencyUsedInCB } from '../../utils/subscription';
import { isAdmin } from 'utils/state';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;
class UpgradeCompanyModal extends Component {

	constructor(props) {
		super(props);
		this.goToSubscription = this.goToSubscription.bind(this);
		let redirectUrl = undefined;

		// set redirectUrl if we are going to redirect to subscription page directly

		// If user has 1 company and is the admin we can go straight to chargebee
		const isAdminOfSingleCompany = this.props.isAdmin && this.props.numberOfCompanies === 1;

		// If app is opened using desktop-app=1 flag and user is admin of requested company, we don't ask user to choose company
		const isAdminOfDesktopAppCompany = this.props.isAdmin && props.isDesktopApp;
		
		if (isAdminOfSingleCompany || isAdminOfDesktopAppCompany) {
			this.goToSubscription();
		}

		this.state = {
			redirectUrl,
			selectedCompanyId: this.props.companyId
		};
	}

	render() {
		const { modalShown, resetModal, companies } = this.props;
		const { redirectUrl, selectedCompanyId } = this.state;
		// redirect to the subscription page
		if (redirectUrl) {
			return <Redirect to={redirectUrl}/>;
		}		

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
			>
					
				{companies.rawDataById[selectedCompanyId].userRole === USER_ROLE_ADMIN ? 
					this.renderAdminDialog() : this.renderMemberDialog()}
			</Dialog>
		);
	}

	renderAdminDialog() {
		return (<React.Fragment>
			<DialogContent>
				<DialogContentText variant='body1' color='default'>
					{localize('upgrade-company-modal-admin-message')}
				</DialogContentText>
			</DialogContent>

			<DialogActions>
				{this.renderCompanySelector()}
			</DialogActions>

			<DialogActions>
				<Button
					key='upgrade-company-button'
					data-tid="button-upgrade-company-continue"
					variant='contained'
					color='primary'
					onClick={ this.goToSubscription }
				>
					{localize('upgrade-company-modal-upgrade')}
				</Button>
			</DialogActions>
		</React.Fragment>);
	}

	renderMemberDialog() {
		return (<React.Fragment>
			<DialogContent>
				<DialogContentText variant='body1' color='default'>
					{localize('upgrade-company-modal-member-message')}
				</DialogContentText>

				<DialogActions>
					{this.renderCompanySelector()}
				</DialogActions>
				
				
				<DialogActions>
					{/* P9052-11801 inform admin not supported yet
					<Button
						disableRipple
						data-tid="button-inform-admin"
						onClick={() => {}}
					>
						Inform Admin
					</Button>*/}
					<Button
						disableRipple
						data-tid="button-create-new-team"
						onClick={() => {

							const queryVars = ['create-company=true'];

							if (this.props.productQuantity) {
								queryVars.push(`${PRODUCT_QUANTITY_PARAM}=${this.props.productQuantity}`);
							}
							if (this.props.productPeriod) {
								queryVars.push(`${PERIOD_PARAM}=${this.props.productPeriod}`);
							}
							if (this.props.productName) {
								queryVars.push(`${PRODUCT_NAME_PARAM}=${this.props.productName}`);
							}
							if (this.props.productSource) {
								queryVars.push(`${PRODUCT_SOURCE_PARAM}=${this.props.productSource}`);
							}
							if (this.props.productLang) {
								queryVars.push(`${PRODUCT_LANGUAGE_PARAM}=${this.props.productLang}`);
							}
							if (this.props.couponId) {
								queryVars.push(`${COUPON_ID_PARAM}=${this.props.couponId}`);
							}
							if (this.props.currency) {
								queryVars.push(`${CURRENCY_PARAM}=${this.props.currency}`);
							}
							if (this.props.planId) {
								queryVars.push(`chargebee-plan-id=${this.props.planId}`);
							}

							const redirectURL = `${XC_URL}?${queryVars.join('&')}`;

							window.location.href = redirectURL;
						}}
					>
						{localize('upgrade-company-modal-create-new-team')}
					</Button>
				</DialogActions>
			</DialogContent>
		</React.Fragment>);
		
	}

	renderCompanySelector() {
		const companies = Object.values(this.props.companies.byId);
		return (<Select
			data-tid="upgrade-company-company-selector"
			value={this.state.selectedCompanyId}
			name="company"
			disableUnderline
			IconComponent={SelectArrow}
			onChange={(event) => {
				this.setState({selectedCompanyId: event.target.value});
			}}
		>
			<MenuItem value="" disabled>{localize('upgrade-company-modal-selector')}</MenuItem>
			{companies.map((company) => {
				return (<MenuItem
					key={company.id}
					value={company.id}
					data-tid={`upgrade-company-item-${company.displayName}`}>
					{company.displayName}
				</MenuItem>);
			})}
		</Select>);
	}

	goToSubscription() {
		// happens on initial purchase only (not for upgrade)
		// we make hard page reload in case we don't support change company by router path
		const { companies } = this.props;
		const companyId = this.state ? this.state.selectedCompanyId : this.props.companyId;

		// Take currency from existing plan of company selected in modal window (as it can't be changed), 
		// otherwise from URL (for plus-overview package), defaults to USD
		let currentPackageCurrency;
		const alreadyUsedCurrency = getCurrencyUsedInCB(companies.rawDataById[companyId]);
		alreadyUsedCurrency && (currentPackageCurrency = alreadyUsedCurrency);

		const currency = currentPackageCurrency || this.props.currency;
		const queryVars = ['company-known=1'];
		if (this.props.productName) {
			queryVars.push(`${PRODUCT_NAME_PARAM}=${this.props.productName}`);
		}
		if (this.props.productQuantity) {
			queryVars.push(`${PRODUCT_QUANTITY_PARAM}=${this.props.productQuantity}`);
		}		
		if (this.props.productSource) {
			queryVars.push(`${PRODUCT_SOURCE_PARAM}=${this.props.productSource}`);
		}
		if (this.props.productPeriod) {
			queryVars.push(`${PERIOD_PARAM}=${this.props.productPeriod}`);
		}		
		if (this.props.productLang) {
			queryVars.push(`${PRODUCT_LANGUAGE_PARAM}=${this.props.productLang}`);
		}
		if (this.props.magixEmail) {
			queryVars.push(`${MAGIX_EMAIL_PARAM}=${this.props.magixEmail}`);
		}		
		if (this.props.magixSerial) {
			queryVars.push(`${MAGIX_SERIAL_PARAM}=${this.props.magixSerial}`);
		}
		if (this.props.magixCat) {
			queryVars.push(`${MAGIX_CATEGORY_PARAM}=${this.props.magixCat}`);
		}		
		if (this.props.couponId) {
			queryVars.push(`${COUPON_ID_PARAM}=${this.props.couponId}`);
		}	
		if (this.props.isUpgradePopup) {
			queryVars.push(`${UPGRADE_POPUP_PARAM}=${this.props.isUpgradePopup}`);
		}
		if (this.props.realEstatePlan) {
			queryVars.push(`${REAL_ESTATE_PLAN_PARAM}=${this.props.realEstatePlan}`);
		}
		if (this.props.isCBPlanExternalRedirect) {
			queryVars.push(`${EXTERNAL_REDIRECT_PARAM}=1`);
		}
		if (this.props.isCBPlanInternalRedirect) {
			queryVars.push(`${INTERNAL_REDIRECT_PARAM}=1`);
		}

		window.location.href = getSubscriptionRedirectUrl(this.props.planId, companyId, currency, queryVars);
		window.location.reload();
		this.props.hideModal();
		this.props.showPreloader();
	}
}

UpgradeCompanyModal.propTypes = {
	companies: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	paymentRedirectUrl: PropTypes.string,
	companyId: PropTypes.string,
	planId: PropTypes.string,
	currency: PropTypes.string,
	productName: PropTypes.string,
	productLang: PropTypes.string,
	magixEmail: PropTypes.string,
	magixSerial: PropTypes.string,
	magixCat: PropTypes.string,
	couponId: PropTypes.string,
	realEstatePlan: PropTypes.bool,
	isUpgradePopup: PropTypes.bool,
	history: PropTypes.object,
	showChargebeeLoader: PropTypes.func,
	showPreloader: PropTypes.func,
	location: PropTypes.shape({
		search: PropTypes.string
	}),
	isDesktopApp: PropTypes.bool,
	isAdmin: PropTypes.bool,
	isCBPlanExternalRedirect: PropTypes.bool,
	isCBPlanInternalRedirect: PropTypes.bool,
	numberOfCompanies: PropTypes.number,
	productQuantity: PropTypes.number,
	productSource: PropTypes.number,
	productPeriod: PropTypes.number
};

const mapStateToProps = state => ({
	modalShown: state.modal.modalShown,
	companies: state.companies,	
	companyId: state.companies.rawDataById[state.companies.selectedId].id,
	paymentRedirectUrl: state.companies.paymentRedirectUrl,
	isAdmin: isAdmin(state),
	numberOfCompanies: Object.values(state.companies.byId).length
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal,
	showChargebeeLoader,
	showPreloader
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(UpgradeCompanyModal);


// WEBPACK FOOTER //
// ./src/components/Modal/UpgradeCompanyModal.js